import api from '../api';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';

const label = 'descriptionEdit';

function handler(apiOptions, actions) {
  const { showDialog, hideDialog, navigateToDir, getSelectedResources, getResource, rootContainer } = actions;

  const getMessage = getMess.bind(null, apiOptions.locale);
  const localeLabel = getMessage(label);
  const selectedResource = getSelectedResources()[0];
  const rawDialogElement = {
    elementType: 'EditDialog',
    elementProps: {
      initialValue: {
        description: selectedResource.description || '',
        id: selectedResource.id,
      },
      onHide: hideDialog,
      rootContainer: rootContainer,
      onSubmit: async (description, id) => {
        hideDialog();
        await api.updateFile(apiOptions, { description, id: id });
        const resource = getResource();
        navigateToDir(resource.id, id);

        return null;
      },
    },
  };
  showDialog(rawDialogElement);
}

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getSelectedResources } = actions;
  return {
    id: label,
    icon: { icon: icons.editDescription },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const selectedResources = getSelectedResources();

      return selectedResources.length === 1 && selectedResources.every((resource) => resource.capabilities.canEdit);
    },
    availableInContexts: ['row', 'toolbar'],
    handler: () => handler(apiOptions, actions),
  };
};
